// Persistent app footer — hyper-scanno DESIGN.md §5a pattern.
//
// Fixed bottom-left of the viewport, panel surface, top-right rounded.
// Carries the same three tokens hyper-scanno uses:
//
//     Captain Tasko v__VERSION__ · © __YEAR__ chadwiki · Help / README
//
// The version comes from the Vite-injected __APP_VERSION__ global,
// year is computed at render time (always live, no rebuild needed),
// and the link points at /help — since CTSK-356 that's the help index
// page (catalog of all help docs grouped by area), so the label is
// plain "Help" (the old "Help / README" label described the v1
// README-rendering behavior).
//
// The build SHA + active-org slug used to live in the sidebar bottom
// strip — they're folded into this footer's hover tooltip so they
// stay one-keystroke-away without adding visible chrome.

import { useSession } from "../hooks/useSession.js";

export interface AppFooterProps {
  /** Called when the Help link is clicked, so the SPA can route to
   *  /help without a full reload. Receiving a callback (rather than
   *  importing the router) keeps this component reusable from any
   *  shell. */
  onNavigate: (path: string) => void;
}

export function AppFooter({ onNavigate }: AppFooterProps) {
  const { session } = useSession();
  const year = new Date().getFullYear();
  const orgSlug = session?.activeOrg?.slug ?? null;
  const orgName = session?.activeOrg?.name ?? null;
  const tooltip =
    `Captain Tasko v${__APP_VERSION__} · build ${__APP_BUILD__}` +
    (orgName ? ` · org "${orgName}" (${orgSlug})` : "");

  return (
    <footer id="app-footer" title={tooltip} aria-label="Application footer">
      Captain Tasko <strong>v{__APP_VERSION__}</strong>
      {" · "}© {year} chadwiki
      {orgSlug && (
        <>
          {" · "}
          <span className="app-footer__org">{orgSlug}</span>
        </>
      )}
      {" · "}
      <a
        href="/help"
        onClick={(e) => {
          e.preventDefault();
          onNavigate("/help");
        }}
      >
        Help
      </a>
    </footer>
  );
}
